<template>
  <div class="tianjinTopMenu">
    <div class="tj-logo">
      <img src="../../../assets/petrifaction/logo.png" alt=""> <span class="tj-title">天津石化设备集中监测平台</span>
    </div>
    <div class="tj-link">
      <ul>
        <li v-for="(item,index) in liData" :key="index" :class="{'active':liIndex == index}" @click="clickLiFun(index)">
          {{item.name}} <div class="line"></div>
        </li>
        <!-- <router-link tag="li" to="/statistics" class="active">数据统计  <div class="line"></div></router-link>
                <router-link tag="li" to="/abnormal">报警及异常处理 <div class="line"></div></router-link>
                <router-link tag="li" to="/monitoringReport">监测报告 <div class="line"></div></router-link> -->
      </ul>
    </div>
    <div class="tj-out">
      <div class="out-img" @click="logout">
        <img src="../../../assets/petrifaction/out.png" alt="">
      </div>
      <div class="news-img">
        <img src="../../../assets/petrifaction/news.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        liIndex: 0,
        liData: [
          {
            router: "/comprehensive",
            name: "综合看板"
          },
          {
            router: "/statistics",
            name: "数据统计"
          },
          {
            router: "/abnormal",
            name: "报警及异常处理"
          },
          {
            router: "/monitoringReport",
            name: "监测报告"
          }
        ],
        shouMenus: false
      }
    },
    created () {

    },
    watch: {

    },
    methods: {
      clickLiFun (i) {
        this.liIndex=i
        this.$router.push(this.liData[i].router)
      },
      logout () {
        // console.log("退出登陆");
        this.shouMenus=false
        this.$store.menuStore.commit('clear')
        this.$dialogMethod.showLoading("正在注销...")
        this.$api.userApi.logout(respon => {
          //清理所有缓存
          toLogin()
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .tianjinTopMenu {
    height: 70px;
    background-color: #073030;
    display: flex;
    align-content: center;
    justify-content: space-between;

    .tj-logo {
      width: 550px;
      height: 100%;
      display: flex;
      align-items: center;

      img {
        width: 55px;
        height: 55px;
        margin: 0px 5px 0px 40px;

      }

      .tj-title {
        color: #fff;
        font-size: 22px;
        font-weight: bold;
      }
    }

    .tj-link {
      display: flex;
      align-content: center;

      ul {
        height: 100%;
        display: flex;
        align-items: center;
        margin-bottom: 0px;

        li {
          color: #999999;
          font-weight: bold;
          font-size: 20px;
          margin: 0px 30px;
          position: relative;
          cursor: pointer;

          .line {
            width: 60px;
            height: 4px;
            background-color: transparent;
            position: absolute;
            bottom: -13px;
            left: 50%;
            margin-left: -30px;
            border-radius: 5px;
          }

          &.active {
            color: #fff;

            .line {
              background-color: #00EFFF;
            }
          }
        }
      }
    }

    .tj-out {
      cursor: pointer;
      display: flex;
      align-items: center;
      margin-right: 60px;

      .out-img {
        margin-right: 40px;
      }
    }
  }
</style>